// extracted by mini-css-extract-plugin
module.exports = {"content-padding":"CorrectSpendModal_content-padding__sPikT"};